import VueI18n from 'vue-i18n'
import {
  LANG as ES
} from '../assets/i18n/es'
import {
  LANG as EN
} from '../assets/i18n/en'
import {
  LANG as PT
} from '../assets/i18n/pt'

export const i18nTranslate = (Vue, locale) => {
  Vue.use(VueI18n)

  const messages = {
    ...ES,
    ...EN,
    ...PT,
  }

  const fallbackLocale = 'en'

  if (!locale) {
    [locale] = String(
      window.navigator.userLanguage || window.navigator.language || 'en'
    ).split('-')
  }

  return new VueI18n({
    locale,
    fallbackLocale,
    messages,
  })
}
